import { config } from "config";
import { options } from "utils";

export const getListaPrecio = async (id) => {
  const resp = await fetch(`${config.URL_API_PRIVATE}/preciosV2/${id}`, options("GET"));
  const data = await resp.json();
  return data;
};

export const getAdicional = async (id) => {
  const resp = await fetch(`${config.URL_API_PRIVATE}/precios/${id}/adicionales1`, options("GET"));
  const data = await resp.json();
  return data;
};

export const createAumentos = async (body) => {
  const resp = await fetch(`${config.URL_API_PRIVATE}/preciosV2/aumentos`, options("POST", body))
  const data = await resp.json()
  return data
};